import FlexibleCancellationPolicyModalWithDates from './FlexibleCancellationPolicyModalWithDates'
import FlexibleCancellationPolicyTimelineModalWithoutDates from './FlexibleCancellationPolicyTimelineModalWithoutDates'
import type { FlexibleCancellationTimelineDetails } from './flexibleCancellationPolicyTimelineUtils'

export interface FlexibleCancellationPolicyTimelineContentProps {
  details: FlexibleCancellationTimelineDetails
  /** Whether this is a charter bundle (flights + hotel). Affects terminology and shows charter-specific fees. */
  isCharter?: boolean
}

/**
 * Shared with/without-dates timeline body used by checkout, offer-page modal, and offer-page summary module.
 */
function FlexibleCancellationPolicyTimelineContent(props: FlexibleCancellationPolicyTimelineContentProps) {
  const { details, isCharter } = props
  const hasDates = !!details.checkInDate && !!details.startBasedOnCheckIn

  return (
    <>
      {hasDates && details.checkInDate && details.startBasedOnCheckIn && (
        <FlexibleCancellationPolicyModalWithDates
          today={details.today}
          checkInDate={details.checkInDate}
          startBasedOnToday={details.startBasedOnToday}
          startBasedOnCheckIn={details.startBasedOnCheckIn}
          cancellationAfterChangeOfMindPeriod={details.cancellationAfterChangeOfMindPeriod}
          isCharter={isCharter}
        />
      )}
      {!hasDates && (
        <FlexibleCancellationPolicyTimelineModalWithoutDates
          days={details.days}
          isCharter={isCharter}
        />
      )}
    </>
  )
}

export default FlexibleCancellationPolicyTimelineContent
